/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReimagineMusicV2Dto
 */
export interface ReimagineMusicV2Dto {
    /**
     * 
     * @type {string}
     * @memberof ReimagineMusicV2Dto
     */
    prompt: string;
    /**
     * <= 180
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof ReimagineMusicV2Dto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof ReimagineMusicV2Dto
     */
    trackName?: string;
    /**
     * 
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    folderId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReimagineMusicV2Dto
     */
    format?: string;
    /**
     * 
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    styleFilterId?: number;
    /**
     * 
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    filterWeight?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReimagineMusicV2Dto
     */
    assist?: boolean;
    /**
     * length of fade out in the end
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    fadeOutLength?: number;
    /**
     * number of tracks
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    tracksNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ReimagineMusicV2Dto
     */
    uploadFileId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReimagineMusicV2Dto
     */
    reimagineType?: string;
}

/**
 * Check if a given object implements the ReimagineMusicV2Dto interface.
 */
export function instanceOfReimagineMusicV2Dto(value: object): value is ReimagineMusicV2Dto {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    return true;
}

export function ReimagineMusicV2DtoFromJSON(json: any): ReimagineMusicV2Dto {
    return ReimagineMusicV2DtoFromJSONTyped(json, false);
}

export function ReimagineMusicV2DtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReimagineMusicV2Dto {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'duration': json['duration'],
        'model': json['model'],
        'trackName': json['trackName'] == null ? undefined : json['trackName'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'format': json['format'] == null ? undefined : json['format'],
        'styleFilterId': json['styleFilterId'] == null ? undefined : json['styleFilterId'],
        'filterWeight': json['filterWeight'] == null ? undefined : json['filterWeight'],
        'assist': json['assist'] == null ? undefined : json['assist'],
        'fadeOutLength': json['fadeOutLength'] == null ? undefined : json['fadeOutLength'],
        'tracksNum': json['tracksNum'] == null ? undefined : json['tracksNum'],
        'uploadFileId': json['uploadFileId'] == null ? undefined : json['uploadFileId'],
        'reimagineType': json['reimagineType'] == null ? undefined : json['reimagineType'],
    };
}

export function ReimagineMusicV2DtoToJSON(json: any): ReimagineMusicV2Dto {
    return ReimagineMusicV2DtoToJSONTyped(json, false);
}

export function ReimagineMusicV2DtoToJSONTyped(value?: ReimagineMusicV2Dto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'duration': value['duration'],
        'model': value['model'],
        'trackName': value['trackName'],
        'folderId': value['folderId'],
        'format': value['format'],
        'styleFilterId': value['styleFilterId'],
        'filterWeight': value['filterWeight'],
        'assist': value['assist'],
        'fadeOutLength': value['fadeOutLength'],
        'tracksNum': value['tracksNum'],
        'uploadFileId': value['uploadFileId'],
        'reimagineType': value['reimagineType'],
    };
}

